import React, { useState,useRef } from "react"; 
import CerrarSesion from "./datainfo/del_dto";
import './menu.css' 
import Iconos from "./iconos/iconos";
import { getMenuUser,getUserName,validSesion,getUserName2, getUserParam } from "./datainfo/dto";

const Menu = () => {
    const boxRef = useRef(null);
    const [show,setShow] = useState(false)

    if(!(validSesion())){ 
        CerrarSesion();
        window.location.assign('/login');
        return;
    } 
    if(getUserParam("blnUserMustChangePassword")==1){
         CerrarSesion();
        window.location.assign('/login');
        return;
    }
    const Cerrarsesion=()=>{ 
        CerrarSesion(); 
        window.location.assign("/dash");
    } 

    const handleClick = () => { 
        if (boxRef.current.classList.contains('show')) {
            boxRef.current.classList.remove('show');
        } else {
            boxRef.current.classList.add('show');
        }
    };

    return(
        <>
            <header className="nav_menu" data-bs-theme="dark" >
                <img src="./../img/IPM_logo.jpg" alt=" >:3 " className=""  />    

                <ul className="navbar-nav flex-row d-md-none">
                    <li className="nav-item text-nowrap">
                        <button className="nav-link px-3 text-white" type="button" onClick={handleClick} data-bs-toggle="offcanvas" data-bs-target="#sidebarMenu" aria-controls="sidebarMenu" aria-expanded="false" aria-label="Toggle navigation"></button>
                    </li>
                    
                </ul> 
                  
               
                <label key={"name-user"} className="text-white mx-1 p-0" htmlFor="">
                    <span> <Iconos icono={"USER"}  width={"30"} height={"25"} fill="#FFF"/> </span>
                    <span>{getUserName().trim().toUpperCase()}</span>
                </label>

                <button onClick={handleClick}  className="btn-menu text-white m-0 p-0" htmlFor="">
                    <span>
                        <Iconos icono={"MENU"}  width={"70"} height={"60"} fill="#aaa"/>
                    </span> 
                </button> 
            </header> 
            
            <div ref={boxRef} className="offcanvas-body d-md-flex flex-column p-0 pt-lg-3 overflow-y-auto panel_menu ">
                    <div  className="menu-body">
                        <ul className="nav nav-items "> 
                            { 
                                getMenuUser() !== null ?
                                    getMenuUser().map((item,index)=>
                                    item.blnIsModal === 0?
                                    <li key={index} id={item.intModuleOptionKey} className="nav-item  ">
                                        <div key={"div_"+index} className="nav-link d-flex align-items-center gap-2 fw-bold menu-item" onClick={()=>{window.location.assign(item.strModuleOptionLanguageId);}}>
                                            <Iconos key={index+"-"+item.strModuleOptionLanguageId} icono={item.strModuleOptionLanguageId}  width={"20"} height={"20"} fill="#04376b"/> 
                                            <label key={item.strModuleOptionDescription} htmlFor="">{item.strModuleOptionDescription}</label>
                                        </div> 
                                    </li>:<span key={index}></span>
                                    )
                                :<></>   
                            }

                        </ul>
                    </div>

                    <div className=" menu-foother">
                        <hr className="m-0" />
                        <ul className="nav bg-light flex-column ">
                            <li className="nav-item">
                                <div className="nav-link d-flex align-items-center gap-2 menu-item" onClick={()=>{Cerrarsesion()}}>
                                    <Iconos icono={"SALIR"}  width={"20"} height={"20"} fill="#04376b"/> 
                                    <label>SALIR</label>
                                </div>
                            </li>
                        </ul>
                    </div>
            </div> 
        </>
    )
}
const Dash=({children})=>{
    return(
        <div className="dash">
            {children}
        </div>
    )
}
export {Menu,Dash};